<template>
    <section
        class="relative overflow-hidden"
        aria-labelledby="homepage-hero-heading"
    >
        <div
            class="absolute inset-0 -z-10"
            aria-hidden="true"
        >
            <div
                class="absolute -top-24 left-1/2 h-72 w-2xl -translate-x-1/2 rounded-full bg-primary-shade-ligth blur-3xl"
            ></div>
            <div
                class="absolute -bottom-24 left-1/3 h-72 w-2xl -translate-x-1/2 rounded-full bg-sky-50 blur-3xl"
            ></div>
        </div>

        <div class="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
            <div class="grid items-center gap-10 lg:grid-cols-2">
                <div>
                    <p
                        class="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-sm font-bold text-slate-700"
                    >
                        <span
                            class="h-2 w-2 rounded-full bg-emerald-500"
                            aria-hidden="true"
                        ></span>
                        For coaches, consultants, and solo experts
                    </p>

                    <h1
                        id="homepage-hero-heading"
                        class="mt-5 text-4xl font-bold tracking-tight sm:text-5xl"
                    >
                        Turn your expertise into bookable services
                    </h1>

                    <p class="mt-4 text-lg text-slate-600">
                        We help coaches, consultants, and solo experts create a
                        professional booking page so clients can book without
                        the back-and-forth.
                    </p>

                    <p class="mt-7">
                        <a
                            :href="authRegisterUrl"
                            class="inline-flex items-center justify-center rounded-lg2 bg-primary px-5 py-3 text-base font-bold text-white shadow-xs shadow-primary-shade-ligth hover:bg-primary-shade"
                        >
                            Start free
                            <LandingPageIcon
                                name="arrow-right"
                                class="ml-2 h-5 w-5"
                                aria-hidden="true"
                            />
                        </a>
                    </p>

                    <ul
                        class="mt-7 hidden gap-3 text-sm text-slate-700 md:grid md:grid-cols-2"
                        aria-label="TinyCal benefits"
                    >
                        <li class="flex items-start gap-2">
                            <span
                                class="mt-0.5 text-emerald-600"
                                aria-hidden="true"
                                >✓</span
                            >
                            Share one clean link for discovery calls and paid
                            sessions
                        </li>
                        <li class="flex items-start gap-2">
                            <span
                                class="mt-0.5 text-emerald-600"
                                aria-hidden="true"
                                >✓</span
                            >
                            Collect intake details before the call starts
                        </li>
                        <li class="flex items-start gap-2">
                            <span
                                class="mt-0.5 text-emerald-600"
                                aria-hidden="true"
                                >✓</span
                            >
                            Prevent double bookings with calendar sync
                        </li>
                        <li class="flex items-start gap-2">
                            <span
                                class="mt-0.5 text-emerald-600"
                                aria-hidden="true"
                                >✓</span
                            >
                            Send reminders and collect payments in one place
                        </li>
                    </ul>

                    <p class="mt-4 text-xs text-slate-500">
                        Pricing starts at
                        <span class="font-bold text-slate-700">$7/month</span>.
                        Cancel anytime.
                    </p>
                </div>

                <div class="relative">
                    <MockBookingForm />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import MockBookingForm from '@/Marketing/LandingPage/Component/LandingPage/MockBookingForm.vue'
    import LandingPageIcon from '@/Marketing/LandingPage/Component/LandingPageIcon.vue'

    const props = defineProps({
        authRegisterUrl: {
            type: String,
            required: true,
        },
    })
</script>
